"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
var money_1 = require("./money");
var money_adapter_1 = require("./money.adapter");
__export(require("./money.symbols"));
__export(require("./money.currencies"));
var REGEX_SEPARATORS = /[\|]+/;
function createMoney(data) {
    var _a = money_adapter_1.Adapter.params(data), amount = _a[0], currency = _a[1], decimal = _a[2];
    return new money_1.MoneyImpl(amount, currency, decimal);
}
exports.createMoney = createMoney;
function splitMoneyString(data) {
    return data.split(REGEX_SEPARATORS);
}
exports.splitMoneyString = splitMoneyString;
function normalizeMoneyAmount(amount, currency, decimals) {
    var numberAmount = money_adapter_1.Adapter.shouldConvertToNumber(amount);
    var decimalUnit = money_adapter_1.Adapter.getDecimalUnit(currency, decimals);
    var value = numberAmount * Math.pow(10, decimalUnit);
    return Number.isInteger(value) ? value : Math.round(value);
}
exports.normalizeMoneyAmount = normalizeMoneyAmount;
//# sourceMappingURL=index.js.map